'use strict';

const { queryFirst } = require('../domUtil');

const liveRegion = queryFirst('.js-live-region');

function announceMessage(message) {
    liveRegion.textContent = message;
    setTimeout(() => {
        liveRegion.textContent = '';
    }, 1000);
}

window.announceMessage = announceMessage;
